import React, { SVGAttributes } from 'react';

export function GuestUserIcon(props: SVGAttributes<unknown>): JSX.Element {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='112' height='112' viewBox='0 0 112 112' fill='none' {...props}>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M56 79.3333C49.8222 79.3333 42.7189 80.9733 37.3333 84C31.9477 87.0267 26.5455 92.7229 23.3333 98C22.1847 99.887 21.6393 99.7654 19.7522 98.6168C17.8652 97.4682 17.2666 95.0073 18.4152 93.1202C22.3411 86.6704 27.8608 81.3395 34.4432 77.6402C41.0257 73.9409 48.4493 71.9978 56 71.9978C63.5507 71.9978 70.9743 73.9409 77.5567 77.6402C84.1392 81.3395 89.6588 86.6704 93.5848 93.1202C94.7334 95.0073 94.1348 97.4682 92.2478 98.6168C90.3607 99.7654 87.482 97.5537 86.3333 95.6667C83.1212 90.3896 80.0523 87.0267 74.6667 84C69.281 80.9733 62.1778 79.3333 56 79.3333Z'
        fill='currentColor'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M16.402 16.402C26.9041 5.89998 41.1479 0 56 0C70.8521 0 85.0959 5.89998 95.598 16.402C106.1 26.9041 112 41.1479 112 56C112 70.8521 106.1 85.0959 95.598 95.598C85.0959 106.1 70.8521 112 56 112C41.1479 112 26.9041 106.1 16.402 95.598C5.89998 85.0959 0 70.8521 0 56C0 41.1479 5.89998 26.9041 16.402 16.402ZM56 8C43.2696 8 31.0606 13.0571 22.0589 22.0589C13.0571 31.0606 8 43.2696 8 56C8 68.7304 13.0571 80.9394 22.0589 89.9411C31.0606 98.9429 43.2696 104 56 104C68.7304 104 80.9394 98.9429 89.9411 89.9411C98.9429 80.9394 104 68.7304 104 56C104 43.2696 98.9429 31.0606 89.9411 22.0589C80.9394 13.0571 68.7304 8 56 8Z'
        fill='currentColor'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M77 46.6667C77 58.2646 67.598 67.6667 56 67.6667C44.402 67.6667 35 58.2646 35 46.6667C35 35.0687 44.402 25.6667 56 25.6667C67.598 25.6667 77 35.0687 77 46.6667ZM56 60.6667C63.732 60.6667 70 54.3987 70 46.6667C70 38.9347 63.732 32.6667 56 32.6667C48.268 32.6667 42 38.9347 42 46.6667C42 54.3987 48.268 60.6667 56 60.6667Z'
        fill='currentColor'
      />
    </svg>
  );
}
